import gql from "graphql-tag";

export const FETCH_FIRMS = gql`
  query FetchFirms(
    $field: FirmsSortFieldsEnum!
    $direction: SortDirectionEnum!
    $page: Int
    $limit: Int
    $FirmName: String
  ) {
    fetchFirms(
      sort: { field: $field, direction: $direction }
      limit: $limit
      page: $page
      filterdropdown: {
        FirmName: $FirmName
      }
    ) {
      FirmsCount
      Firms {
        extrn_company_id
        extrn_company_name
        address_line_1
        city
        state
        zip
      }
    }
  }
`;

export const CREATE_FIRM = gql`
  mutation CreateFirm(
    $extrn_company_name: String!
    $extrn_addr_line1: String!
    $extrn_addr_line2: String
    $extrn_city_name: String!
    $extrn_st_prov_cd: String!
    $extrn_postal_cd: String!
  ) {
    createFirm(
      firm: {
        extrn_company_name: $extrn_company_name
        extrn_addr_line1: $extrn_addr_line1
        extrn_addr_line2: $extrn_addr_line2
        extrn_city_name: $extrn_city_name
        extrn_st_prov_cd: $extrn_st_prov_cd
        extrn_postal_cd: $extrn_postal_cd
      }
    ) {
      Success
      message
      extrn_company_id
    }
  }
`;

export const FETCH_FIRM_FOR_EDIT = gql`
  query FetchFirmForEdit(
    $external_company_id: Int!
  ) {
    fetchFirmForEdit(
      external_company_id: $external_company_id
    ) {
      external_company_id
      extrn_company_name
      extrn_addr_line1
      extrn_addr_line2
      extrn_city_name
      extrn_st_prov_cd
      extrn_postal_cd
    }
  }
`;

export const UPDATE_FIRM_FOR_EDIT = gql`
  mutation UpdateFirmForEdit(
    $external_company_id: Int!
    $extrn_company_name: String!
    $extrn_addr_line1: String!
    $extrn_addr_line2: String
    $extrn_city_name: String!
    $extrn_st_prov_cd: String!
    $extrn_postal_cd: String!
  ) {
    updateFirmForEdit(
      firm: {
        external_company_id: $external_company_id
        extrn_company_name: $extrn_company_name
        extrn_addr_line1: $extrn_addr_line1
        extrn_addr_line2: $extrn_addr_line2
        extrn_city_name: $extrn_city_name
        extrn_st_prov_cd: $extrn_st_prov_cd
        extrn_postal_cd: $extrn_postal_cd
      }
    ) {
      Success
      message
      external_company_id
    }
  }
`;

export const CHECK_FIRM_NAME_EXISTS = gql`
  query CheckFirmNameExists(
    $extrn_company_name: String!
    $external_company_id: Int
  ) {
    checkFirmNameExists(
      extrn_company_name: $extrn_company_name
      external_company_id: $external_company_id
    ) {
      exists
      message
    }
  }
`;
